import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {UIReplayView} from '../../../shared/scripts/ui_replay/elements/UIReplayView'
import {PIXI} from '@colonist/pixi'

export class UIWReplayView extends UIReplayView {
    setPosition() {
        super.setPosition()
        let zoom = 1
        if(UIUtilsEjsVariables.isUserOnMobile) zoom = 0.5
        if(PIXI.isMobile.tablet) zoom = 1
        if(UIUtilsEjsVariables.isUserOnDiscord) zoom = 0.75

        const MARGIN = this.uiGameManager.canvasController.margin
        const canvasX = this.uiGameManager.canvasController.responsiveController.getCanvasX()
        const canvasY = this.uiGameManager.canvasController.responsiveController.getCanvasY()
        const chatWidth = this.uiGameManager.canvasController.chatWidth
        const replayMaxWidth = 400
        this.mainBlock.style.width = Math.min(replayMaxWidth, (chatWidth / zoom)) + 'px'
        this.setPositionRight(canvasX + MARGIN + chatWidth + MARGIN)
        this.setPositionTop(canvasY + MARGIN)
    }
}
